import Paragraph from "@/components/Paragraph.vue";

export const paragraphInit = {
    component: Paragraph,
    name: "Formatted Text",
    models: ["content-section"],
    inputs: [
        {
            name: "text",
            type: "richText"
        }
    ]
};
